export const Input = ({ ...props }) => {
  return (
    <input className="bg-bgAlt w-full px-3 py-5 type-label-l rounded-sm text-text placeholder:text-accent" {...props} />
  )
}
